import { Link } from 'react-router-dom';
import { useEffect } from 'react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    const s = document.createElement('script');
    s.src = 'https://cdn.iubenda.com/iubenda.js';
    s.async = true;
    document.body.appendChild(s);
    return () => {
      try {
        if (s.parentNode) s.parentNode.removeChild(s);
      } catch (e) {}
    };
  }, []);

  return (
    <footer className="bg-zinc-950 text-zinc-400 border-t-4 border-red-600 w-full max-w-full overflow-hidden">
      {/* Top Banner: 24/7 Readiness */}
      <div className="bg-zinc-900/90 py-6 border-b border-zinc-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row items-center justify-between gap-4 text-center md:text-left">
          <div className="flex items-center gap-3">
            <span className="flex h-4 w-4 relative shrink-0">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-4 w-4 bg-red-600"></span>
            </span>
            <div>
              <p className="font-condensed text-lg sm:text-xl font-bold uppercase tracking-wider text-white">
                VAGTCENTRAL DØGNET RUNDT – 365 DAGE OM ÅRET
              </p>
              <p className="text-xs text-zinc-400">
                Akut assistance, autohjælp og bjærgning i hele Danmark og Europa
              </p>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <a
              href="tel:+4570700800"
              className="inline-flex items-center justify-center gap-2.5 px-5 sm:px-6 py-3 bg-red-600 hover:bg-red-700 text-white font-condensed text-lg sm:text-xl font-bold uppercase rounded shadow-lg transition-transform active:scale-95 whitespace-nowrap"
            >
              <i className="fa-solid fa-phone" aria-hidden="true" />
              <span>RING +45 70 700 800</span>
            </a>
          </div>
        </div>
      </div>

      {/* Main Footer Grid */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Col 1: Brand & Presentation */}
          <div className="space-y-4">
            <Link to="/" className="inline-block">
              <img
                src="/_assets/mc-transport-logo.png"
                alt="MC Transport logo - Vognmand med autotransport og autohjælp"
                className="h-12 w-auto max-w-[200px] object-contain brightness-110 bg-white p-[5px] rounded"
              />
            </Link>
            <p className="text-xs leading-relaxed text-zinc-300">
              MC Transport er din pålidelige partner inden for autotransport, autohjælp, bjærgning og specialtransport. Vi er en familieejet vognmandsforretning med døgnvagt 24/7/365.
            </p>
            <div className="pt-2">
              <span className="inline-block text-xs font-mono font-semibold text-zinc-400 bg-zinc-900 px-3 py-1.5 rounded border border-zinc-800">
                CVR-nummer: 33311184
              </span>
            </div>
            <div className="pt-2">
              <a
                href="https://www.facebook.com/MCautotransport/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-sm font-semibold text-white hover:text-blue-400 transition-colors"
                aria-label="Besøg MC Transport på Facebook"
              >
                <span className="w-8 h-8 rounded bg-[#1877f2] flex items-center justify-center text-white">
                  <i className="fa-brands fa-facebook-f" aria-hidden="true" />
                </span>
                <span>Følg os på Facebook</span>
              </a>
            </div>
          </div>

          {/* Col 2: Locations & Contact */}
          <div>
            <h3 className="text-white font-condensed text-lg font-bold uppercase tracking-wider mb-4 border-b border-zinc-800 pb-2">
              Adresser & Kontakt
            </h3>
            <ul className="space-y-3.5 text-xs text-zinc-300">
              <li className="flex items-start gap-2.5">
                <i className="fa-solid fa-location-dot text-red-500 mt-1 shrink-0" aria-hidden="true" />
                <div>
                  <strong className="block text-white font-semibold">MC Transport – Ugerløse</strong>
                  <span>Annexgårdsvej 7, 4350 Ugerløse</span>
                </div>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="fa-solid fa-location-dot text-red-500 mt-1 shrink-0" aria-hidden="true" />
                <div>
                  <strong className="block text-white font-semibold">MC Transport – Odense</strong>
                  <span>Energivej 36, 5260 Odense</span>
                </div>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="fa-solid fa-location-dot text-red-500 mt-1 shrink-0" aria-hidden="true" />
                <div>
                  <strong className="block text-white font-semibold">MC Transport – Hedensted</strong>
                  <span>Lundagervej 4, 8722 Hedensted</span>
                </div>
              </li>
              <li className="pt-2">
                <span className="block text-zinc-400 text-[11px] uppercase font-bold tracking-wider mb-1">
                  Vagtcentral 24/7 (Hele døgnet):
                </span>
                <a
                  href="tel:+4570700800"
                  className="inline-flex items-center gap-2 text-base font-bold text-red-400 hover:text-red-300 transition-colors whitespace-nowrap"
                >
                  <i className="fa-solid fa-phone" aria-hidden="true" />
                  <span>+45 70 700 800</span>
                </a>
              </li>
              <li>
                <span className="block text-zinc-400 text-[11px] uppercase font-bold tracking-wider mb-1">
                  E-mail:
                </span>
                <a
                  href="mailto:kontor@mcautotransport.dk"
                  className="text-white hover:text-red-400 transition-colors whitespace-nowrap font-medium"
                >
                  kontor@mcautotransport.dk
                </a>
              </li>
            </ul>
          </div>

          {/* Col 3: Primary Services */}
          <div>
            <h3 className="text-white font-condensed text-lg font-bold uppercase tracking-wider mb-4 border-b border-zinc-800 pb-2">
              Udvalgte Ydelser
            </h3>
            <ul className="space-y-2 text-xs">
              <li>
                <Link to="/autohjaelp" className="hover:text-red-400 transition-colors flex items-center justify-between">
                  <span>Autohjælp 24/7</span>
                  <span className="text-[10px] bg-red-600 text-white font-bold px-1.5 py-0.2 rounded">AKUT</span>
                </Link>
              </li>
              <li>
                <Link to="/ydelser/autotransport-ydelser" className="hover:text-red-400 transition-colors">
                  Autotransport
                </Link>
              </li>
              <li>
                <Link to="/bugsering-af-bil" className="hover:text-red-400 transition-colors">
                  Bugsering af bil
                </Link>
              </li>
              <li>
                <Link to="/bugsering-af-lastbil" className="hover:text-red-400 transition-colors">
                  Bugsering af lastbil
                </Link>
              </li>
              <li>
                <Link to="/bjaergning" className="hover:text-red-400 transition-colors">
                  Bjærgning af biler
                </Link>
              </li>
              <li>
                <Link to="/fritraekning" className="hover:text-red-400 transition-colors">
                  Fritrækning (4x4)
                </Link>
              </li>
              <li>
                <Link to="/daekcenter" className="hover:text-red-400 transition-colors flex items-center justify-between">
                  <span>Dækcenter (Hedensted)</span>
                  <span className="text-[10px] bg-zinc-800 text-zinc-300 px-1 rounded">1/11-2026</span>
                </Link>
              </li>
              <li>
                <Link to="/bilopbevaring" className="hover:text-red-400 transition-colors">
                  Bilopbevaring
                </Link>
              </li>
              <li>
                <Link to="/daekcenter-lastbil" className="hover:text-red-400 transition-colors">
                  Dækcenter til lastbil
                </Link>
              </li>
              <li>
                <Link to="/daekskift-lastbil" className="hover:text-red-400 transition-colors">
                  Dækskift til lastbil
                </Link>
              </li>
              <li>
                <Link to="/ydelser/krantransport" className="hover:text-red-400 transition-colors">
                  Krantransport (28 tm)
                </Link>
              </li>
              <li>
                <Link to="/ydelser/maskintransport" className="hover:text-red-400 transition-colors">
                  Maskintransport
                </Link>
              </li>
              <li>
                <Link to="/skiltevogn" className="hover:text-red-400 transition-colors">
                  Skiltevogn
                </Link>
              </li>
              <li>
                <Link to="/TMA" className="hover:text-red-400 transition-colors">
                  TMA køretøj
                </Link>
              </li>
              <li>
                <Link to="/tow-truck" className="hover:text-red-400 transition-colors">
                  Tow Truck / English
                </Link>
              </li>
              <li>
                <Link to="/ydelser/transport-paa-sengetrailer" className="hover:text-red-400 transition-colors">
                  Transport på sengetrailer
                </Link>
              </li>
              <li>
                <Link to="/ydelser/gardintrailer-medbringertruck" className="hover:text-red-400 transition-colors">
                  Gardintrailer m. medbringertruck
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 4: Shortcuts & Navigation */}
          <div>
            <h3 className="text-white font-condensed text-lg font-bold uppercase tracking-wider mb-4 border-b border-zinc-800 pb-2">
              Navigation & Information
            </h3>
            <ul className="space-y-2 text-xs">
              <li>
                <Link to="/" className="hover:text-red-400 transition-colors">
                  Forside
                </Link>
              </li>
              <li>
                <Link to="/ydelser" className="hover:text-red-400 transition-colors">
                  Alle ydelser
                </Link>
              </li>
              <li>
                <Link to="/om-os" className="hover:text-red-400 transition-colors">
                  Om MC Transport & Martin
                </Link>
              </li>
              <li>
                <Link to="/galleri" className="hover:text-red-400 transition-colors">
                  Galleri (Vores biler & arbejde)
                </Link>
              </li>
              <li>
                <Link to="/chauffoer-soeges" className="hover:text-red-400 transition-colors font-semibold text-white">
                  Ledige job
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="hover:text-red-400 transition-colors">
                  Kontakt os / Få tilbud
                </Link>
              </li>
              <li>
                <a
                  href="https://www.iubenda.com/privacy-policy/54269040"
                  className="iubenda-white iubenda-noiframe iubenda-embed hover:text-red-400 transition-colors"
                  title="Privatlivspolitik "
                >
                  Privatlivspolitik
                </a>
              </li>
              <li>
                <a
                  href="https://www.iubenda.com/privacy-policy/54269040/cookie-policy"
                  className="iubenda-white iubenda-noiframe iubenda-embed hover:text-red-400 transition-colors"
                  title="Cookiepolitik "
                >
                  Cookiepolitik
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom copyright line */}
        <div className="mt-12 pt-8 border-t border-zinc-800/80 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-zinc-400">
          <p>
            © {currentYear} MC Transport · Alle rettigheder forbeholdes · CVR: 33311184
          </p>
          <div className="flex flex-wrap items-center gap-3">
            <span>Landsdækkende autotransport & autohjælp 24/7</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
